export const getFilterSeriesId = state => state.examsFilters.seriesId
export const getExamFiltersPublishStatus = state => state.examsFilters.publishStatus
